export default "__VITE_ASSET__078811db__"